import { Box, Divider, Typography } from "@mui/material"
import { DeviceSetup } from "graphql/types"

import { MiniGalery } from "components/MiniGalery.tsx/MiniGalery"

type TaskAddDeviceCardProps = {
  deviceSetup: DeviceSetup[]
}

export const TaskAddDeviceCard = (props: TaskAddDeviceCardProps) => {
  const { deviceSetup } = props

  return (
    <>
      {deviceSetup?.map((item) => (
        <Box key={item.device.id} sx={{ mt: 1 }}>
          <Typography variant="body2">
            {item.device.barcode} {item.device.name}
          </Typography>
          <Typography variant="body2"> </Typography>
          {item.linkedTo && item.linkedTo.length > 0 && (
            <Typography variant="body2">
              Verbunden mit: {item.linkedTo?.map((linked) => linked?.device.barcode).join(", ")}
            </Typography>
          )}

          <MiniGalery images={item.images} deleteButton={false} />
          <Divider sx={{ mt: -2 }} />
        </Box>
      ))}
    </>
  )
}
